export default function page(hit, overline) {
  const { excerpt } = hit;

  return `
    <div class="tease tease--search">
      ${hit[overline] ? `<span class="tease__overline">${hit[overline]}</span>` : ''}
      <div class='tease__inner'>
        <a class="tease__hgroup" href="${hit.url}">
          <h3 class="tease__h">
            <span class="tease__h-underline">${hit.title}</span>
          </h3>
        </a>
        ${excerpt ? `<p class="tease__desc">${excerpt}</p>` : ''}
      </div>
    </div>
  `;
}
